<script>
import AccordionItemAlgoServer from "./AccordionItemAlgoServer";

export default {
  name: "AccordionAlgoServer",
  components: { AccordionItemAlgoServer },
  props: {
    content: Array,
    dataItem: Object,
  },
};
</script>
<template>
  <div class="accordion box" role="presentation">
    <accordion-item-algo-server
      v-for="item in content"
      :item="item"
      :key="item.id"
      :dataItem="dataItem"
    >
    </accordion-item-algo-server>
  </div>
</template>
